import React, { useState } from 'react';
import { ManagePages } from './management/ManagePages';
import { ManageNavigation } from './management/ManageNavigation';
import { ManageSocialLinks } from './management/ManageSocialLinks';
import { ManageTextFiles } from './management/ManageTextFiles';

export const SiteManagementPanel: React.FC = () => {
    const [activeTab, setActiveTab] = useState('pages');

    return (
        <div className="mt-8">
            <h2 className="text-xl font-bold text-indigo-700 mb-4">Admin: Site Management</h2>
            <div className="bg-indigo-50 rounded-lg p-6 border border-indigo-200">
                <div className="border-b border-indigo-200 mb-4">
                    <nav className="-mb-px flex space-x-6">
                        <button onClick={() => setActiveTab('pages')} className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${activeTab === 'pages' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>
                            Manage Pages
                        </button>
                        <button onClick={() => setActiveTab('navigation')} className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${activeTab === 'navigation' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>
                            Manage Navigation
                        </button>
                        <button onClick={() => setActiveTab('social')} className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${activeTab === 'social' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>
                            Manage Social Links
                        </button>
                        <button onClick={() => setActiveTab('textfiles')} className={`whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm ${activeTab === 'textfiles' ? 'border-indigo-500 text-indigo-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}>
                            Manage Text Files
                        </button>
                    </nav>
                </div>

                {activeTab === 'pages' && <ManagePages />}
                {activeTab === 'navigation' && <ManageNavigation />}
                {activeTab === 'social' && <ManageSocialLinks />}
                {activeTab === 'textfiles' && <ManageTextFiles />}
            </div>
        </div>
    );
};